import bigTitle from './Header/bigTitle.png'
import loginIcon from './Header/login.png'
import logoutIcon from './Header/logout.png'
import analysisIcon from './Header/analysisIcon.png'
import likeIcon from './Header/likeIcon.png'
import rollbackIcon from './Header/rollbackIcon.png'
import adminIcon from './Header/adminIcon.png'
import star from './DetailsPage/star.svg'
import selectBackground from './AuthorInfoPage/selectBackground.png'
import checkAllBtn from './AuthorInfoPage/checkAllBtn.png'
import checkDetailBtn from './AuthorInfoPage/checkDetailBtn.png'
import eye from './AuthorInfoPage/eye.png'
import prevBtn from './DetailsPage/prev.png'
import nextBtn from './DetailsPage/next.png'
import sun from './DetailsPage/sunIcon.png'
import moon from './DetailsPage/moonIcon.png'
import upBtn from './DetailsPage/upBtn.png'
import downBtn from './DetailsPage/downBtn.png'
import emptyStar from './GenerationPage/star.png'
import fillStar from './GenerationPage/star-fill.png'
import emptyRhythm from './GenerationPage/empty.svg'
import firstRhythm from './GenerationPage/first.svg'
import secondRhythm from './GenerationPage/second.svg'
import thirdRhythm from './GenerationPage/third.svg'
import fourthRhythm from './GenerationPage/fourth.svg'
import smallPen from './GenerationPage/smallPen.svg'
import upArrow from './uparrow.svg'
import museum from './museum.svg'
import RightArrow from './RightArrow.svg'
import ancient from './ancient.svg'
import fanhui from '../images/fanhui.svg'
import annotations from '../images/text.svg'
import audios from '../images/audio.svg'
import videos from '../images/video.svg'
import images from '../images/image.svg'
import bianjiao from '../images/SixLawsPage/构图/边角构图.png'
import zhezhi from '../images/SixLawsPage/构图/折枝式构图.png'
import chuizhi from '../images/SixLawsPage/构图/垂直线构图.png'
import jiazixing from '../images/SixLawsPage/构图/甲字形构图.png'
import liangxian from '../images/SixLawsPage/构图/两线构图.png'
import mangou from '../images/SixLawsPage/构图/满构图.png'
import sandie from '../images/SixLawsPage/构图/三叠两段式构图.png'
import sanfen from '../images/SixLawsPage/构图/三分法构图.png'
import sanjiao from '../images/SixLawsPage/构图/三角形构图.png'
import sanjiaoshanshui from '../images/SixLawsPage/构图/三角形构图（山水）.png'
import sanxian from '../images/SixLawsPage/构图/三线构图.png'
import shuiping from '../images/SixLawsPage/构图/水平线构图.png'
import xuzi from '../images/SixLawsPage/构图/须字形构图.png'
import youzi from '../images/SixLawsPage/构图/由字形构图.png'
import zezi from '../images/SixLawsPage/构图/则字形构图.png'
import zhizi from '../images/SixLawsPage/构图/之字形构图.png'
import zhizishanshui from '../images/SixLawsPage/构图/之字形构图（山水）.png'
import zhongxin from '../images/SixLawsPage/构图/中心构图.png'
import zhongxinjpg from '../images/SixLawsPage/构图/中心构图.jpeg'
import mainLogo from '../images/Header/logo.svg'

export const name2url = {
  '折枝式构图.png': zhezhi,
  '边角构图.png': bianjiao,
  '垂直线构图.png': chuizhi,
  '甲字形构图.png': jiazixing,
  '两线构图.png': liangxian,
  '满构图.png': mangou,
  '三叠两段式构图.png': sandie,
  '三分法构图.png': sanfen,
  '三角形构图.png': sanjiao,
  '三角形构图（山水）.png': sanjiaoshanshui,
  '三线构图.png': sanxian,
  '水平线构图.png': shuiping,
  '须字形构图.png': xuzi,
  '由字形构图.png': youzi,
  '则字形构图.png': zezi,
  '之字形构图.png': zhizi,
  '之字形构图（山水）.png': zhizishanshui,
  '中心构图.png': zhongxin,
  '中心构图.jpeg': zhongxinjpg
}

//Header/Footer组件
export {
  bigTitle,
  loginIcon,
  logoutIcon,
  analysisIcon,
  likeIcon,
  rollbackIcon,
  adminIcon,
  upArrow,
  mainLogo
}

//搜索结果页面
export { selectBackground, checkAllBtn, checkDetailBtn, museum, RightArrow, ancient }

//画作细节页面
export { star, prevBtn, nextBtn, upBtn, downBtn, sun, moon }

//分析页面
export { eye }

//创作生成
export {
  emptyStar,
  fillStar,
  emptyRhythm,
  firstRhythm,
  secondRhythm,
  thirdRhythm,
  fourthRhythm,
  smallPen
}

// 画作对比
export { fanhui }

// 专家dashboard
export { annotations }
export { audios }
export { images }
export { videos }
